import { useField } from 'formik';
import { memo } from 'react';

const SmsConsentField = memo(({ name = 'smsConsent' }) => {
  const [field, meta, helpers] = useField({ name, type: 'checkbox' });
  const hasError = meta.touched && meta.error;

  return (
    <div className="w-full">
      <label className="flex w-full cursor-pointer items-center gap-2 desktop:gap-2.5">
        <input
          type="checkbox"
          checked={field.value}
          onChange={(e) => helpers.setValue(e.target.checked)}
          onBlur={field.onBlur}
          name={field.name}
          className="icon-md shrink-0 cursor-pointer rounded-control-sm border-merchant-text-placeholder accent-merchant-action"
        />
        <span className="desktop:text-[16px] text-sm font-normal leading-3.75 desktop:leading-5 text-merchant-text-secondary">
          I agree to receive SMS messages (including OTPs, account alerts, and updates) from Dine
          Savvy. Reply STOP to opt-out.
        </span>
      </label>
      {hasError && <p className="mt-1 desktop:text-[12px] text-[10px] text-error">{meta.error}</p>}
    </div>
  );
});

SmsConsentField.displayName = 'SmsConsentField';

export default SmsConsentField;
